import React, { useState, useEffect } from 'react';
import {
  IconButton,
  Grid,
  Box,
  Typography,
  Divider,
  Button,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import buscaCep from 'cep-promise';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Alert from '@material-ui/lab/Alert';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
import SearchIcon from '@material-ui/icons/Search';
// components
import { useHistory, useParams } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Notification from '../../utils/notification';
import DeleteDialog from '../../components/DeleteDialog';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import { useUserState } from '../../context/UserContext';
import useStyles from './styles';
import api from '../../services/api';
import {
  cnpjMask, telefoneMask, cepMask, removeCaracteres
} from '../../utils/mask';
import { getError } from '../../utils/getResponseError';
import validarCNPJ from '../../utils/cnpjValidator';

export default function CadastroCliente() {
  const history = useHistory();
  const classes = useStyles();
  const layoutDispatch = useLayoutDispatch();
  const { usuario } = useUserState();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [error, setError] = useState();
  const [errorCep, setErrorCEP] = useState(null);
  const [data, setData] = useState({
    nome: '',
    nome_fantasia: '',
    cnpj: '',
    email: '',
    telefone: '',
    ie: '',
    cep: '',
    endereco: '',
    numero: '',
    bairro: '',
    cidade: '',
    estado: '',
    meios: ['email']
  });

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getCliente(id);
    }
  }, [id]);

  async function getCep(value) {
    toggleLoading(layoutDispatch);
    setErrorCEP(null);
    try {
      const dados = await buscaCep(value);
      setData({
        ...data,
        cidade: dados.city,
        bairro: dados.neighborhood,
        estado: dados.state,
        endereco: dados.street,
        cep: cepMask(value),
      });
    } catch (error) {
      setErrorCEP('CEP inválido');
    }
    toggleLoading(layoutDispatch);
  }

  async function getCliente(id) {
    toggleLoading(layoutDispatch);
    try {
      const { data: result } = await api.get(`/cliente/${id}`);
      const meios = [];
      result.MeiosDeEnvio.map((item) => {
        if (item.nome === 'Email') {
          meios.push('email');
        } if (item.nome === 'WhatsApp') {
          meios.push('whatsapp');
        }
        return null;
      });
      setData({
        ...result,
        cep: cepMask(result.cep),
        cnpj: cnpjMask(result.cnpj),
        telefone: telefoneMask(result.telefone),
        meios
      });

      toggleLoading(layoutDispatch);
    } catch (error) {
      toggleLoading(layoutDispatch);
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
      history.push('/app/clientes');
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const cpfCnpj = removeCaracteres(data.cnpj);

    if (cpfCnpj.length === 14 && !validarCNPJ(cpfCnpj)) {
      return setError('Informe um CNPJ válido');
    }

    if (data.meios.length === 0) {
      return setError('Selecione um meio de envio de notificação');
    }

    setIsSubmiting(true);
    try {
      const obj = {
        nome: data.nome,
        nome_fantasia: data.nome_fantasia !== '' ? data.nome_fantasia : null,
        cnpj: cpfCnpj,
        email: data.email,
        telefone: removeCaracteres(data.telefone),
        ie: data.ie !== '' ? data.ie : null,
        cep: removeCaracteres(data.cep),
        endereco: data.endereco,
        numero: data.numero,
        bairro: data.bairro,
        cidade: data.cidade,
        estado: data.estado,
        id_empresa: usuario.usuario.id_empresa,
        meiosDeEnvio: data.meios.map((meio) => {
          if (meio === 'email') {
            return 1;
          }
          return 2;
        })
      };
      if (id) {
        await api.put(`cliente/${id}`, obj);
        Notification({
          type: 'shipped',
          message: 'Cliente atualizado',
          variant: 'contained',
          color: 'success',
        });
      } else {
        await api.post('cliente', obj);
        Notification({
          type: 'shipped',
          message: 'Cliente cadastrado',
          variant: 'contained',
          color: 'success',
        });
      }

      history.push('/app/clientes');
    } catch (error) {
      setError(getError(error));
    }
    setIsSubmiting(false);
  }

  function handleChange(e) {
    const { name, value: oldValue } = e.target;
    let value = oldValue;

    if (name === 'cnpj') {
      value = cnpjMask(value);
    } else if (name === 'telefone') {
      value = telefoneMask(value);
    } else if (name === 'cep') {
      value = cepMask(value);
      if (value.length === 9 && value !== data.cep) {
        getCep(removeCaracteres(value));
      }
    }

    setData((old) => ({ ...old, [name]: value }));
  }

  function handlePreferencia(e) {
    const { value } = e.target;

    if (value === '1') {
      // email
      if (data.meios.includes('email')) {
        setData((prev) => ({
          ...prev,
          meios: prev.meios.filter((m) => m !== 'email')
        }));
      } else {
        setData((prev) => ({
          ...prev,
          meios: [...prev.meios, 'email']
        }));
      }
      return;
    }
    // whatsapp
    if (data.meios.includes('whatsapp')) {
      setData((prev) => ({
        ...prev,
        meios: prev.meios.filter((m) => m !== 'whatsapp')
      }));
    } else {
      setData((prev) => ({
        ...prev,
        meios: [...prev.meios, 'whatsapp']
      }));
    }
  }

  async function getCnpj() {
    const cnpj = removeCaracteres(data.cnpj);

    if (cnpj.length !== 14) {
      return;
    }

    if (!validarCNPJ(cnpj)) {
      return Notification({
        type: 'report',
        message: 'CNPJ inválido',
        variant: 'contained',
        color: 'secondary',
      });
    }

    toggleLoading(layoutDispatch);

    try {
      const { data: result } = await api.get(`/cnpj/${cnpj}`);

      setData((old) => ({
        ...old,
        nome: result.nome,
        nome_fantasia: result.fantasia,
        email: result.email,
        cep: cepMask(removeCaracteres(result.cep)),
        cidade: result.municipio,
        numero: result.numero,
        bairro: result.bairro,
        endereco: result.logradouro,
        estado: result.uf
      }));
    } catch (error) {
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
    }
    toggleLoading(layoutDispatch);
  }

  return (
    <>
      <PageTitle
        title="Cadastro de clientes"
        button={(
          <IconButton
            color="primary"
            aria-label="cadastrar novo cliente"
            className={classes.addButton}
            onClick={() => history.push('/app/clientes')}
          >
            <KeyboardReturnIcon />
          </IconButton>
        )}
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget disableWidgetMenu>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Grid container item xs={12}>
                <Grid item sm={12} xs={12}>
                  <Box px={3} pt={0} pb={0}>
                    <Typography variant="h5" color="textSecondary" noWrap>
                      Dados cadastrais
                    </Typography>
                    <Divider className={classes.divider} />
                  </Box>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Razão social"
                      fullWidth
                      value={data.nome}
                      name="nome"
                    />
                  </Box>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box px={3} py={2} display="flex" alignItems="center">
                    <TextField
                      onChange={handleChange}
                      required
                      label="CPF/CNPJ"
                      fullWidth
                      value={data.cnpj}
                      name="cnpj"
                    />
                    {data.cnpj.length === 18 && (
                      <IconButton
                        color="primary"
                        aria-label="cadastrar novo cliente"
                        className={classes.cnpjButton}
                        onClick={getCnpj}
                      >
                        <SearchIcon />
                      </IconButton>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      label="Nome fantasia"
                      fullWidth
                      value={data.nome_fantasia}
                      name="nome_fantasia"
                    />
                  </Box>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Email"
                      fullWidth
                      value={data.email}
                      name="email"
                    />
                  </Box>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Celular"
                      fullWidth
                      value={data.telefone}
                      name="telefone"
                      inputProps={{
                        maxLength: 15
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      label="Inscrição Estadual"
                      fullWidth
                      value={data.ie}
                      name="ie"
                    />
                  </Box>
                </Grid>
                <Grid item sm={12} xs={12}>
                  <Box px={3} pt={7} pb={0}>
                    <Typography variant="h5" color="textSecondary" noWrap>
                      Endereço
                    </Typography>

                    <Divider className={classes.divider} />
                  </Box>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="CEP"
                      fullWidth
                      value={data.cep}
                      name="cep"
                      error={!!errorCep}
                      helperText={errorCep}
                      inputProps={{
                        maxLength: 9
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Endereço"
                      fullWidth
                      value={data.endereco}
                      name="endereco"
                    />
                  </Box>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Número"
                      fullWidth
                      value={data.numero}
                      name="numero"
                    />
                  </Box>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Bairro"
                      fullWidth
                      value={data.bairro}
                      name="bairro"
                    />
                  </Box>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Cidade"
                      fullWidth
                      value={data.cidade}
                      name="cidade"
                    />
                  </Box>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Box px={3} py={2}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={data.estado || ''}
                        name="estado"
                        onChange={handleChange}
                        required
                      >
                        <MenuItem value="AC">Acre</MenuItem>
                        <MenuItem value="AL">Alagoas</MenuItem>
                        <MenuItem value="AP">Amapá</MenuItem>
                        <MenuItem value="AM">Amazonas</MenuItem>
                        <MenuItem value="BA">Bahia</MenuItem>
                        <MenuItem value="CE">Ceará</MenuItem>
                        <MenuItem value="DF">Distrito Federal</MenuItem>
                        <MenuItem value="ES">Espírito Santo</MenuItem>
                        <MenuItem value="GO">Goiás</MenuItem>
                        <MenuItem value="MA">Maranhão</MenuItem>
                        <MenuItem value="MT">Mato Grosso</MenuItem>
                        <MenuItem value="MS">Mato Grosso do Sul</MenuItem>
                        <MenuItem value="MG">Minas Gerais</MenuItem>
                        <MenuItem value="PA">Pará</MenuItem>
                        <MenuItem value="PB">Paraíba</MenuItem>
                        <MenuItem value="PR">Paraná</MenuItem>
                        <MenuItem value="PE">Pernambuco</MenuItem>
                        <MenuItem value="PI">Piauí</MenuItem>
                        <MenuItem value="RJ">Rio de Janeiro</MenuItem>
                        <MenuItem value="RN">Rio Grande do Norte</MenuItem>
                        <MenuItem value="RS">Rio Grande do Sul</MenuItem>
                        <MenuItem value="RO">Rondônia</MenuItem>
                        <MenuItem value="RR">Roraima</MenuItem>
                        <MenuItem value="SC">Santa Catarina</MenuItem>
                        <MenuItem value="SP">São Paulo</MenuItem>
                        <MenuItem value="SE">Sergipe</MenuItem>
                        <MenuItem value="TO">Tocantins</MenuItem>
                        <MenuItem value="EX">Estrangeiro</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item sm={12} xs={12}>
                  <Box px={3} pt={7} pb={0}>
                    <Typography variant="h5" color="textSecondary" noWrap>
                      Preferências da notificação
                    </Typography>

                    <Divider className={classes.divider} />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box px={3} py={2}>
                    <FormControlLabel
                      control={(
                        <Checkbox
                          checked={data.meios.includes('whatsapp')}
                          onChange={handlePreferencia}
                          name="WhatsApp"
                          color="primary"
                          value={2}
                        />
                      )}
                      label="WhatsApp"
                    />
                    <FormControlLabel
                      control={(
                        <Checkbox
                          checked={data.meios.includes('email')}
                          onChange={handlePreferencia}
                          name="Email"
                          color="primary"
                          value={1}
                        />
                      )}
                      label="Email"
                    />
                  </Box>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={12} sm={8}>
                    <Box px={3} py={2} color="red">
                      {error && (
                        <Alert severity="error">{error}</Alert>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Box px={3} py={2} className={classes.botaoDireta}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={isSubmiting}
                      >
                        {isSubmiting ? <CircularProgress size={25} /> : 'Salvar'}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
